import { render, staticRenderFns } from "./CouponGroup.vue?vue&type=template&id=78c5ee04&"
import script from "./CouponGroup.vue?vue&type=script&lang=js&"
export * from "./CouponGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports